interface ProductCharacteristic {
	name: string;
	value: string;
}

interface Result {
	resultDescription: string;
	resultCode: string;
	resultTime: string;
}

export type CreditLimit = {
	productCharacteristic: ProductCharacteristic;
	result: Result;
};

const model: types.models.InputModel = {
	productCharacteristic: 'response.getProductsResponse.product.productCharacteristic',
	result: 'response.getProductsResponse.result.result',
};

export default model;
